import axios from '@/services/http/axios'

const recuperaLogin = (context) =>
  new Promise((resolve, reject) => {
    let refreshToken = localStorage.getItem('api_refreshToken')
    if (refreshToken !== null) {
      axios.post('/auth/refreshToken', { refreshToken: refreshToken })
        .then(response => {
          context.commit('AUTH', response.data)
          context.commit('LOGIN', response.data.usuario)
        }).catch(error => {
          console.log(error)
        })
    }
  })

const login = (context, form) =>
  new Promise((resolve, reject) => {
    // context.commit('CHECK')

    localStorage.setItem('api_lembrar', form.lembrarLogin)

    if (form.lembrarLogin) {
      localStorage.setItem('api_login', form.email)
    } else {
      localStorage.removeItem('api_login')
    }

    axios
      .post('/auth/login', form)
      .then(response => {
        context.commit('AUTH', response.data)
        context.commit('LOGIN', response.data.usuario)

        context
          .dispatch('check')
          .then(data => resolve(data), error => reject(error))
      })
      .catch(error => {
        context.dispatch('logout')
        reject(error.response.data)
      })
  })

const logout = (context) => {
  return new Promise(resolve => {
    context.commit('LOGOUT')
    resolve()
  })
}

const check = context =>
  new Promise((resolve, reject) => {
    context.commit('CHECK')
    let token = context.state.auth.token
    // let authorization = `JWT ${context.state.auth.token}`
    let authorization = `bearer ${context.state.auth.token}`
    if (token !== null) {
      axios.defaults.headers.common['Authorization'] = authorization
      resolve()
    } else {
      context.dispatch('logout')
      reject(new Error('Autenticação não encontrada!'))
    }
  })

export default {
  login,
  logout,
  check,
  recuperaLogin
}
